import { gql } from '@apollo/client';

const removeAgentIdForInterest = gql`
  mutation ($variables: InteresentById!) {
    agentIdRemovingForInteresent(input: $variables)
  }
`;
export default removeAgentIdForInterest;
